import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SignupPage from '../pages/SignupPage';
import LoginPage from '../pages/LoginPage'
import ProtectedRoute from "../components/layouts/ProtectedRoute";
import NotFound from "../pages/NotFoundPage";
import BoardsPage from "../pages/BoardsPage";
import BoardPage from "../pages/BoardPage";
import {ProfilePage} from "../pages/ProfilePage";
import MetricsPage from "../pages/MetricsPage";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import SsoCallbackPage from "../pages/SsoCallbackPage";
import DeleteAccountInfoPage from "../pages/DeleteAccountInfoPage";

const AppRouter: React.FC = () => {
  return (
        <Routes>
            <Route path='/' element={
                <ProtectedRoute>
                    <BoardsPage />
                </ProtectedRoute>
            } />
            <Route path='/signup' element={<SignupPage />} />
            <Route path='/login' element={<LoginPage />} />
            <Route path='/login/sso' element={<SsoCallbackPage />} />
            <Route path={'/forgot-password'} element={<ForgotPasswordPage />} />
            <Route path={'/reset-password'} element={<ResetPasswordPage />} />
            <Route path={'/boards'} element={<ProtectedRoute><BoardsPage /></ProtectedRoute>} />
            <Route path={'/boards/:boardId'} element={<ProtectedRoute><BoardPage /></ProtectedRoute>} />
            <Route path={'/account'} element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path={'/privacy'} element={<PrivacyPolicyPage />} />
            <Route path={'/delete-account'} element={<DeleteAccountInfoPage />} />
            <Route path={'/metrics'} element={<ProtectedRoute><MetricsPage /></ProtectedRoute>} />
            <Route path="*" element={<NotFound />} />
        </Routes>
  );
};

export default AppRouter;